<template>
  <div>
    <!--  -->
    <div class="w-full antialiased">
      <div class="flex justify-center">
        <nav id="nav" class="relative w-full" v-if="info.param_params">
          <span
            class="transition-medium border-ontick-steel-500 dark:border-ontick-green-500 dark:bg-ontick-graphite-500 absolute h-10 w-full rounded border-r-4 bg-gray-200 shadow transition-transform ease-out"
            :style="{ transform: `translateY(calc(100% * ${section_index}))` }"
          ></span>
          <ul class="relative">
            <li
              v-for="(item, key) in info.param_params"
              :key="item.section_name"
            >
              <button
                type="button"
                @click="sectionIndex(key)"
                :aria-selected="section_index === key"
                class="flex w-full items-center py-2 px-3 focus:outline-none focus-visible:underline"
              >
                <span
                  :class="
                    section_index === key
                      ? 'text-gray-600 dark:text-gray-300'
                      : 'text-gray-600'
                  "
                  class="text-ontick-base transition-medium whitespace-nowrap font-normal transition-all ease-out"
                >
                  {{ item.section_name }}
                </span>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- <transition
      enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
      enter-class="translate-x-full"
      enter-to-class="translate-x-0"
      leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
      leave-class="translate-x-0"
      leave-to-class="translate-x-full"
    >
      <div
        v-show="tabMobile"
        class="fixed inset-y-0 right-0 pl-10 max-w-full flex z-50"
      >
        <transition
          enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
          enter-class="translate-x-full"
          enter-to-class="translate-x-0"
          leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
          leave-class="translate-x-0"
          leave-to-class="translate-x-full"
        >
          <div v-show="tabMobile" class="w-screen max-w-md">
            <div
              class="
                h-full
                flex flex-col
                py-6
                backdrop-filter backdrop-blur-sm
                bg-ontick-carbon-500 bg-opacity-75
                backdrop-opacity-90
                shadow-xl
                overflow-y-scroll
              "
            >
              <div class="px-4 sm:px-6">
                <div class="flex items-start justify-between mb-6">
                  <div class="h-7 mr-auto">
                    <button
                      @click="tabMobile = !tabMobile"
                      class="
                        px-1
                        py-1
                        text-gray-400
                        hover:text-gray-400
                        focus:outline-none
                      "
                    >
                      <span v-html="$icons.arrow_left" />
                    </button>
                  </div>
                </div>
                <nav id="nav" class="w-full relative" v-if="info.param_params">
                  <span
                    class="
                      absolute
                      h-10
                      w-full
                      bg-ontick-steel-500
                      border-r-4 border-ontick-green-500
                      rounded
                      shadow
                      ease-out
                      transition-transform transition-medium
                    "
                    :style="{
                      transform: `translateY(calc(100% * ${section_index}))`,
                    }"
                  ></span>
                  <ul class="relative">
                    <li
                      v-for="(item, key) in info.param_params"
                      :key="item.section_name"
                    >
                      <button
                        type="button"
                        @click="sectionIndex(key), (tabMobile = false)"
                        :aria-selected="section_index === key"
                        class="
                          w-full
                          flex
                          items-center
                          focus:outline-none
                          focus-visible:underline
                        "
                      >
                        <span
                          :class="
                            section_index === key
                              ? 'text-gray-200'
                              : 'text-gray-400'
                          "
                          class="
                            text-ontick-base
                            font-normal
                            transition-all
                            ease-out
                            transition-medium
                          "
                        >
                          {{ item.section_name }}
                        </span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition> -->

    <!-- <button
      @click="tabMobile = !tabMobile"
      class="
        md:hidden
        mr-6
        mb-20
        fixed
        bottom-0
        right-0
        z-50
        bg-ontick-blue-700
        rounded-full
        px-2
        py-2
        h-10
        w-10
      "
    >
      <svg
        class="w-6 h-6 text-gray-300"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
        ></path>
      </svg>
    </button> -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "edit-section",
  data() {
    return {
      tabActive: "",
      tabMobile: false,
      styles: {
        tabActive:
          "bg-ontick-graphite-500 border-ontick-green-500 text-white font-medium",
        tabInactive:
          "bg-ontick-carbon-500 border-ontick-carbon text-ontick-font-nineth hover:text-white hover:font-medium",
        tabAll:
          "block px-3 py-2 border-r-4 transform transition ease-in-out duration-300 sm:duration-500 transition-all",
      },
    };
  },
  computed: {
    ...mapState({
      selectedParameter: (state) =>
        state.investment.parameters.selectedParameter,
      info: (state) => state.investment.parameters.info,
      section_index: (state) => state.investment.parameters.section_index,
    }),
  },
  watch: {
    selectedParameter(value) {
      if (value) {
        this.getParamInfo({
          investment_id: this.$route.params.investment_id,
          param_id: value.param_id,
        });
      }
      return value;
    },
  },
  methods: {
    ...mapActions({
      getParamInfo: "investment/getParamInfo",
      sectionIndex: "investment/sectionIndex",
    }),
  },
};
</script>

<style lang="scss" scoped>
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.transition-fastest {
  transition-duration: 75ms;
}
.transition-faster {
  transition-duration: 100ms;
}
.transition-fast {
  transition-duration: 150ms;
}
.transition-medium {
  transition-duration: 200ms;
}
.transition-slow {
  transition-duration: 300ms;
}
.transition-slower {
  transition-duration: 500ms;
}
.transition-slowest {
  transition-duration: 700ms;
}
.transition-all {
  transition-property: all;
}
.transition-opacity {
  transition-property: opacity;
}
.transition-transform {
  transition-property: transform;
}
.focus-visible.focus-visible\:underline {
  text-decoration: underline;
}
</style>
